import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import React from 'react'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'
import { CommonButtonSettings } from '../../settings/button/common-button-settings'

export const RegistrationButtonSettings = ({
  entity,
  defaultEntity,
}: SettingsProps<RegistrationButtonEntityInterface>) => {
  return (
    <>
      <ButtonTypeGroup entity={entity} />
      <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
    </>
  )
}
